import { useMutation } from '@tanstack/react-query';
import { HttpService } from '@Services/api/httpService';

interface ValidateMfaRequest {
  answer: string;
}

export interface ValidateMfaResponse {
  stateToken: string;
  allowEditingPersonalDetails: boolean;
  token?: string;
  skipQuestion?: boolean;
}

export const validatePhoneMfa = async (customerId: string, data: ValidateMfaRequest) => {
  const url = `v5/onboarding/secondary/${customerId}/validateMfa`;

  const response = await HttpService.post<ValidateMfaResponse>(url, {
    answer: data.answer,
    mfaType: 'SMS',
  });

  return response.data;
};

export const useValidatePhoneMfa = (customerId: string) =>
  useMutation({
    mutationFn: (data: ValidateMfaRequest) => validatePhoneMfa(customerId, data),
  });
